import PortalContent from './PortalContent';

export default PortalContent;
